import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { IMAGE_URL } from '../Component/Baseurl';
import { Link } from 'react-router-dom';
import defaultImage from "../Component/img/event1.jfif";

function Filterdata({ results, loading }) {
  if (loading) {
    return (
      <div className="text-center py-5">
        <FontAwesomeIcon icon={faSpinner} spin size="3x" />
        <p>Loading events...</p>
      </div>
    );
  }

  return (
    <div className="row g-1">
      {results.length > 0 ? (
        results.map((event) => (
          <div key={event.event_unique_id} className="col-md-12 col-12 mb-3">
            <Link
              to={`/${
                event.source_table === "exhibition_master"
                  ? `exhibition/${event.event_slug}`
                  : event.source_table === "conference_master"
                  ? `conference/${event.event_slug}`
                  : event.source_table === "workshop_master"
                  ? `${event.event_slug}/workshop`
                  : event.source_table === "concert_master"
                  ? `${event.event_slug}/concert`
                  : event.source_table === "sport_master"
                  ? `${event.event_slug}/sport`
                  : event.event_slug
              }`}
              target="_blank"
              className="event-card-link"
            >
              <div className="event-card">
                <div className="d-flex text-start justify-content-between">
                  <div className="p-3 text-start">
                    <span className="ft-tags">
                      {new Date(event.start_date).toLocaleDateString("en-GB")} ,{" "}
                      {new Date(event.end_date).toLocaleDateString("en-GB")}
                    </span>
                    <h4 className="ft-event">{event.event_name}</h4>
                    <h6 className="plaq">{event.venue_name}</h6>
                    <p className="p1">{event.venue_address}</p>
                    <div className="badge bg-gradient-primary etype">
                      {event.frequency || "N/A"}
                    </div>
                  </div>
                  <div className="p-3">
                    <img
                      src={
                        event.eventbanner
                          ? `${IMAGE_URL}eventFiles/${event.eventbanner}`
                          : defaultImage
                      }
                      alt={event.event_name}
                      className="img-fluid eventimg2"
                    />
                  </div>
                </div>
                <div className="event-details text-start px-3 pb-3">
                  <div>{event.organised_by}</div>
                  {event.industries?.length > 0 && (
                    <div className="industries">
                      {event.industries.map((industry, idx) => (
                        <span key={idx}>#{industry} </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </div>
        ))
      ) : (
        <p>No events found.</p>
      )}
    </div>
  );
}

export default Filterdata;
